<template>
    <!-- Figma P2/P3 "Cash" card -->
    <div class="min-h-full flex flex-col gap-[12px] font-roboto">
        <div class="flex justify-start items-center gap-1 w-full">
            <div class="w-[8px] h-[8px] rounded-full bg-[#A084E8]" />
            <div class="w-[35px] h-[8px] rounded-full bg-[#A084E8]" />
            <p class="text-[18px] laptop:text-[20px] font-semibold pl-2 m-0 text-[#333333]">Cash</p>
        </div>
        <p class="m-0 text-[14px] text-[#333333]">
            Please pay the amount <span class="font-semibold">${{ $helper.formatAmount(invoiceDetail?.amount ?? '0') }}</span>
            in cash to the fyxify <span class="font-semibold">PRO</span> to proceed further.
        </p>
        <div class="fxInfoBox flex items-center gap-[8px]">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true" class="flex-shrink-0"><circle cx="12" cy="12" r="9" stroke="#3B82F6" stroke-width="2" /><path d="M12 11v5M12 8h.01" stroke="#3B82F6" stroke-width="2" stroke-linecap="round" /></svg>
            Confirm the cash has been handed over before signing and completing the payment.
        </div>
    </div>
</template>
<script>
export default {
    props: ['invoiceDetail']
}
</script>
